import useAssignments from './useAssignments';
import useStudents from './useStudents';
import useStudentSubmissions from './useStudentSubmissions';
import useAssignmentsAssigneeModels from './useAssignmentsAssigneeModels';

const useGradesTableData = () => {
  useStudents();
  useAssignments();
  useStudentSubmissions();
  useAssignmentsAssigneeModels();
};

export default useGradesTableData;
